import classNames from 'classnames'
import BSCard from 'react-bootstrap/Card'

import Spinner from '@/components/Spinner/Spinner'
import { CommandersPageProps } from '@/types/page'
import getParams from '@/utils/getParams'
import useDirectories from '@/utils/useDirectories'

import styles from './NavigationPanel.module.scss'
import NavigationPanelBracket from './NavigationPanelBracket'
import NavigationPanelBudget from './NavigationPanelBudget'
import NavigationPanelRelated from './NavigationPanelRelated'
import NavigationPanelTags from './NavigationPanelTags'
import NavigationPanelTop from './NavigationPanelTop'

type Props = {
  data: CommandersPageProps['data']
}

const NavigationPanel = ({ data }: Props) => {
  const directories = useDirectories()
  const card = data.container.json_dict.card

  if (!card) {
    return (
      <BSCard className={classNames(styles.navigation, 'justify-content-center shadow-sm')}>
        <Spinner className='fa-2x' />
      </BSCard>
    )
  }

  if (directories.dir === 'cards' && !card.legal_commander && !card.type.includes('Background')) {
    return null
  }

  const { bracket, budget, colorId, tag } = directories.dir !== 'precon' ? getParams(directories) : {}

  const tagLinks = data.panels?.taglinks

  // Disable budget buttons if the currently selected commander+tag has <10 decks
  const numDecks = data.container.json_dict.card.num_decks
  const disableBudgetButtons = !budget && numDecks < 10

  return (
    <BSCard
      className={classNames(styles.navigation, 'shadow-sm', {
        'justify-content-start': tagLinks?.length === 0,
      })}
    >
      <NavigationPanelTop bracket={bracket} budget={budget} card={card} colorId={colorId} tag={tag} />

      {!['cards', 'deckpreview', 'partners', 'precon'].includes(directories.dir) && (
        <>
          <NavigationPanelBracket
            bracket={bracket}
            bracketCounts={data.bracket_counts}
            budget={budget}
            colorId={colorId}
            sanitized={card.sanitized}
            tag={tag}
          />
          <NavigationPanelBudget
            bracket={bracket}
            budget={budget}
            colorId={colorId}
            disabled={disableBudgetButtons}
            sanitized={card.sanitized}
            tag={tag}
          />
        </>
      )}

      {tagLinks ? (
        <>
          <NavigationPanelTags
            bracket={bracket}
            budget={budget}
            colorId={colorId}
            sanitized={card.sanitized || ''}
            tag={tag}
            tags={tagLinks}
          />
        </>
      ) : data.partnercounts ? (
        <NavigationPanelRelated related={data.partnercounts} title='Partners' />
      ) : (
        data.precon_commander_counts && (
          <NavigationPanelRelated related={data.precon_commander_counts} title='Commanders' />
        )
      )}
    </BSCard>
  )
}

export default NavigationPanel
